import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { resolveHtmlLegacyRoute } from '../models/content';

/** Redirects `#home`, `#about`, etc. from standalone HTML; unknown hashes go home. */
export function useHtmlHashRedirect() {
  const { hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!hash) return;
    const target = resolveHtmlLegacyRoute(hash);
    if (!target) return;
    navigate(target, { replace: true });
  }, [hash, navigate]);
}
